module.exports = __webpack_public_path__ + "static/media/photoshop.7ab43dd2.png";